import {
  boolean,
  literal,
  nonsensitive,
  number,
  object,
  optional,
  pipe,
  string,
  union,
} from '@sail/comms';

export const sailDataObservabilityEventSchema = object({
  type: pipe(string(), nonsensitive()),
  service: pipe(string(), nonsensitive()),
  project: pipe(string(), nonsensitive()),
  component: pipe(string(), nonsensitive()),
  operation_name: pipe(string(), nonsensitive()),
  operation_prefetch: pipe(boolean(), nonsensitive()),
  operation_prefetch_hit: pipe(boolean(), nonsensitive()),
  operation_deduplicate: pipe(boolean(), nonsensitive()),
  network_duration: pipe(optional(number()), nonsensitive()),
  variables: pipe(string(), nonsensitive()),
  error_expected: pipe(optional(boolean()), nonsensitive()),
  error_muted: pipe(optional(boolean()), nonsensitive()),
  error_source: pipe(optional(string()), nonsensitive()),
});

export const sailDataPrefetchCounterEventSchema = object({
  typeOfMetric: pipe(
    union([literal('overprefetch'), literal('underprefetch')]),
    nonsensitive(),
  ),
  operationName: pipe(string(), nonsensitive()),
  service: pipe(string(), nonsensitive()),
  project: pipe(string(), nonsensitive()),
  component: pipe(string(), nonsensitive()),
  pathname: pipe(string(), nonsensitive()),
});
